import styled from 'styled-components';
import {
  theme, themenew
} from '../../../common/color';


export const ProductWrapper = styled.div`
  padding-top: 1.25rem;
  background: #fff;
  .space-carousel {
    padding: 2rem 0;
    overflow: hidden;
  }
`
export const ProductTitle = styled.div`
  width: 65%;
  margin-left: 4%;
  float: left;
  >div{
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 1.875rem;
    margin-bottom: 0.75rem;
  }
  >span{
    font-size: 0.875rem;
  }
`
export const CollectionButton = styled.div`
  background-image: linear-gradient(135deg, #0060EC 0%, #B82CFC 100%);
  border-radius: 4px;
  width: 3.625rem;
  height: 1.75rem;
  color: #fff;
  font-size: 0.875rem;
  line-height: 1.75rem;
  text-align: center;
  margin-right: 4%;
  float: right;
`
export const CollectionButtonSelect = styled.div`
  background: #f1f1f1;
  border-radius: 4px;
  width: 3.625rem;
  height: 1.75rem;
  color: ${themenew.text_color};
  font-size: 0.875rem;
  line-height: 1.75rem;
  text-align: center;
  margin-right: 4%;
  float: right;
`
export const Tabs = styled.div`
  width:100%;
  margin:0 auto 0.5rem;
  display:flex;
  overflow-x:auto;
  overflow-y:hidden;
  font-size:1rem;
  ::-webkit-scrollbar{
		width:0;
		height: 0;
		display:none;
	}
  >div{
    padding:0 4%;
    flex-shrink: 0;
    color:${themenew.text_color};
    margin-top:0.33rem;
    >div{
      width:1.625rem;
      height:0.1875rem;
      margin:0.3rem auto 0;
      background-color:#4228CF;
      border-radius:0.093rem;
    }
  }
  .selected{
    font-size:1rem;
    font-weight:700;
  }
`
export const SplitLine = styled.div`
  border-bottom: 0.5px solid #D6D6D6;
`
export const ProductDetailBox = styled.div`
  padding: 1rem 4%;
  line-height: 1.25rem;
  font-size: 0.875rem;
  min-height: 10rem;
  video{
    width: 100%;
    background: #000;
    margin: 1rem 0;
  }
  img{
    width: 100%;
    background: #000;
    margin: 1rem 0;
  }
`
export const ListItem = styled.div`
  margin-bottom: 1rem;
  div{
    display: inline-block;
    margin-right: 1rem;
    font-size: 0.75rem;
    color: #7C8698;
  }
  span{
    display: inline-block;
    color: #203152;
    font-size: 0.75rem;
  }
`

export const DistributorBox = styled.div`
  width: 100%;
  height: 5rem;
  border-bottom: 0.5px solid #d6d6d6;
  padding-top: 1.25rem;
`
export const DistributorImg = styled.div`
  background: #000000;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.10);
  border-radius: 6px;
  width: 2.875rem;
  height: 2.875rem;
  overflow:hidden;
  display:flex;
  justify-content: center;
  align-items: center;
  float: left;
  margin-right: 0.5rem;
  img{
    width:100%;
    min-height: 2.875rem;
    object-fit: cover;
  }
`
export const DistributorTitle = styled.div`
  float: left;
  width: 60%;
  >div{
    font-size: 0.875rem;
    color: ${themenew.text_color};
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 0.3rem;
  }
  span{
    font-size: 0.75rem;
    color: ${themenew.subtext_color};
  }
`
export const DistributorBotton = styled.div`
  margin-top: 0.6rem;
  background: #771AE3;
  border-radius: 6px;
  color: #fff;
  font-size: 0.75rem;
  line-height: 1.625rem;
  height: 1.625rem;
  text-align: center;
  width: 4.25rem;
  float: right;
`
export const TopDownload = styled.div`
  width:100%;
  line-height:3.125rem;
  height: 3.125rem;
  background-color: #fff;
  position: fixed;
  top:0;
  z-index:999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  
  >img{
    width: 7.75rem;
    height: 2.375rem;
  }
  
  >div{
    flex: 1;
    margin-left: 1rem;
    >div{
      font-size: 0.875rem;
      color: #203152;
      line-height: 1.2;
    }
    >span{
      font-size: 0.75rem;
      color: #7C8698;
    }
  }
  
  >a{
    width: 4.5rem;
    height: 1.75rem;
    line-height: 1.75rem;
    background-image: linear-gradient(135deg, #0060EC 0%, #B82CFC 100%);
    border-radius: 4px;
    font-size: 0.875rem;
    text-align: center;
    color: #fff;
  }
`

export const NumWrapper = styled.div` 
  width: 92%;
  min-height: 60px;
  margin-left: 4%;
  background: rgba(255,255,255,0.90);
  box-shadow: 0 3px 7px 0 rgba(0,0,0,0.05);
  border-radius: 0.375rem;
  margin-bottom: 1.25rem;
  padding: 12px 15px 10px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  .price-row {
    font-size: 12px;
    color: ${themenew.subtext_color};
    margin-bottom: 8px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    >span {
      font-size: 20px;
      color: ${themenew.error_color};
      margin-left: 2px;
      white-space: nowrap;
      vertical-align: bottom;
    }
    >label {
      color: ${themenew.error_color};
    }
  }
  .action-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    width: 100%;
  }
`

export const PayButton = styled.div`
  height: 1.75rem;
  line-height: 1.75rem;
  padding: 0 1rem;
  background: linear-gradient(135deg, #0060EC 0%, #B82CFC 100%);
  border-radius: 4px;
  color: #fff;
  font-size: 0.875rem;
  cursor: pointer;
  margin-left: 10px;
`

export const PayModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .modal-content {
    position: relative;
    width: 90%;
    max-width: 500px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: auto;
      display: block;
    }

    .close-btn {
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 2rem;
      height: 2rem;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 1.2rem;
      cursor: pointer;
      z-index: 1001;
      
      &:before {
        content: "×";
        line-height: 1;
      }
    }
  }
`